<form class="h-100 d-flex flex-column"
        *ngIf="template$ | async as template"
        [formGroup]="quickSearchForm"
        (ngSubmit)="search()"
        autocomplete="off"
        novalidate>

    <div class="search-form-wrapper quick-search-form-list">
      <rlst-search-form-list
        *ngFor="let dataElement of template.dataElementList; let i = index"
        [formArrayName]="dataElement.fieldCode"
        [searchList]="quickSearchForm.get(dataElement.fieldCode)"
        [dataElement]="dataElement"
        [expanded]="true"
        (operatorValueChanged)="onOperatorValueChanged($event, dataElement)"
        (fieldAdded)="onFieldAdded($event, dataElement)">
      </rlst-search-form-list>
    </div>

    <div class="search-controls">
      <button type="reset" class="btn btn-primary clear-all btn-lg" (click)="clearSearch($event)">
        Clear All
      </button>
      <button type="submit" class="btn-custom btn-custom-dark ml-5 search-btn btn-lg" [disabled]="!quickSearchForm.valid || isFormEmpty">
        Search
      </button>

      <div class="pagination-container">
        <ng-content select=".js-grid-pagination"></ng-content>
      </div>
    </div>
</form>
